export const projectTypes: { id: string; label: string; name: string }[] = [
  {
    id: 'companyCompletedAffordable',
    name: 'affordable',
    label: 'Affordable',
  },
  {
    id: 'companyCompletedWorkForce',
    name: 'workForce',
    label: 'Work Force',
  },
  {
    id: 'companyCompletedMaraketRate',
    name: 'maraketRate',
    label: 'Market Rate',
  },
  {
    id: 'companyCompletedSenior',
    name: 'senior',
    label: 'Senior',
  },
  {
    id: 'companyCompletedMixedIncome',
    name: 'mixedIncome',
    label: 'Mixed Income',
  },
  {
    id: 'companyCompletedMixedUse',
    name: 'mixedUse',
    label: 'Mixed Use',
  },
  {
    id: 'companyCompletedCommercialProject',
    name: 'commercialProject',
    label: 'Commercial Project',
  },
];
export const constructionTypes: { id: string; label: string; name: string }[] = [
  {
    id: 'companyCompletedNewConstruction',
    name: 'newConstruction',
    label: 'New Construction',
  },
  {
    id: 'companyCompletedHistoricRenovation',
    name: 'historicRenovation',
    label: 'Historic Renovation',
  },
  {
    id: 'companyCompletedRenovation',
    name: 'renovation',
    label: 'Renovation',
  },
  {
    id: 'companyCompletedAdaptiveReuse',
    name: 'adaptiveReuse',
    label: 'Adaptive Reuse',
  },
  {
    id: 'companyCompletedInplaceRenovation',
    name: 'inplaceRenovation',
    label: 'In-Place Renovation',
  },
];
export const companyRoles: { id: string; label: string; name: string }[] = [
  {
    id: 'companyCompletedLeadSponsor',
    name: 'leadSponsor',
    label: 'Lead Sponsor/Managing Member',
  },
  {
    id: 'companyCompletedCoSponsor',
    name: 'coSponsor',
    label: 'Co-Sponsor',
  },
  {
    id: 'companyCompletedLimitedPartner',
    name: 'limitedPartner',
    label: 'Limited Partner',
  },
  {
    id: 'companyCompletedSourcedOpportunity',
    name: 'sourcedOpportunity',
    label: 'Sourced Opportunity',
  },
  {
    id: 'companyCompletedFullOwner',
    name: 'fullOwner',
    label: 'Full Owner',
  },
];

export const initialValues: { [key: string]: { [key: string]: any } } = {
  projectName: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  dateCompleted: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  streetAddress: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  city: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  state: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 3,
      maxLength: 150,
    },
  },
  zipCode: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
      minLength: 5,
      maxLength: 5,
    },
  },
  grossBuildingArea: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  housingUnits: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: false,
      min: 0,
    },
  },
  developmentCost: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
      max: 999999999999999,
    },
  },
  projectTypes: {
    value: [],
    error: '',
    isTouched: false,
    rules: {
      type: 'array',
      required: true,
      minLength: 1,
    },
  },
  constructionTypes: {
    value: [],
    error: '',
    isTouched: false,
    rules: {
      type: 'array',
      required: true,
      minLength: 1,
    },
  },
  companyRole: {
    value: [],
    error: '',
    isTouched: false,
    rules: {
      type: 'array',
      required: true,
      minLength: 1,
    },
  },
  partialOwner: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: false,
      min: 0,
      max: 100,
    },
  },
};
